export default __webpack_public_path__ + "static/metaimage-70c198af49c0fac3e98ca04535f059b6.png";